<script setup>
  import { ref, defineProps, watch, defineEmits, onMounted, onBeforeUnmount } from "vue";
  import { debounce } from "lodash";
  import { bus } from "./bus";

  const props = defineProps({
    searchOptions: {
      type: Array,
      default: () => []
    },
    searchTerm: {
      type: String,
      default: ""
    },
  });

  const trans = (key) => {
    return _.get(window.translations, key, key);
  };

  const search = ref("");
  const emits = defineEmits(['update:searchTerm']);
  watch(() => props.searchTerm, (newVal) => {
    search.value = newVal || "";
  }, { immediate: true });

  const onSearchChange = debounce(() => {
    emits("update:searchTerm", search.value);
  }, 300);

  function localResetSearch() {
    search.value = "";
    emits("update:searchTerm", search.value);
  }

  onMounted(() => {
    bus.on('filters:reset', localResetSearch);

    const url = new URL(window.location);
    if (url.searchParams.has('q')) {
      search.value = url.searchParams.get('q');
    }

    if (props.searchTerm) {
      search.value = props.searchTerm;
    }
  });

  onBeforeUnmount(() => bus.off('filters:reset', localResetSearch));
</script>

<template>
    <input
      class="search-colours"
      id="search"
      v-model="search"
      @input="onSearchChange"
      type="text"
      placeholder="Search tiles, collections, or styles...">
    <button disabled class="button-colours">{{ trans('Search') }}</button>

</template>

<style src="vue-multiselect/dist/vue-multiselect.css"></style>
<style>



</style>
